<div class="square-outer" [ngClass]="{ error: error, style: style }">
  <div class="row">
    <div *ngFor="let item of message; let i = index">
      <h2>{{ item | translate: translationParams }}</h2>
    </div>
  </div>
</div>
